import React from "react";
import { SectionLabel, Reveal } from "../primitives";
import { Section, H2, BODY } from "../shared";
import sonnenblumenImg from "@/assets/img/luisa-sonnenblumen.jpeg";

export default function AlleineSection() {
  return (
    <Section testId="alleine-section" className="py-24 md:py-36">
      <SectionLabel testId="alleine-label">Vielleicht fragst Du Dich jetzt:</SectionLabel>
      <Reveal>
        <h2 className={`${H2} mb-12 max-w-3xl text-3xl md:text-5xl`}>Kann ich das nicht einfach alleine machen?</h2>
      </Reveal>
      <div className="grid gap-14 md:grid-cols-12">
        <div className="space-y-6 md:col-span-7">
        <Reveal delay={0.05}>
          <p className={BODY}>Klar <em>kannst</em> Du. Du kannst Podcasts hören, Ratgeber lesen, Tests machen, Freund:innen befragen...</p>
        </Reveal>
        <Reveal delay={0.08}>
          <p className={`${BODY} italic text-cognac-2`}>Allerdings: Wie lange versuchst Du es schon alleine? <span className="not-italic">😬</span></p>
        </Reveal>
        <Reveal delay={0.1}>
          <p className={BODY}>Klarheit ist kein Kopfthema.</p>
        </Reveal>
        <Reveal delay={0.105}>
          <p className={BODY}>
            Sie entsteht nicht durch noch mehr Nachdenken, sondern durch ein neues Bewusstsein – eins, das Du allein oft nicht erreichst.
          </p>
        </Reveal>
        <Reveal delay={0.11}>
          <p className={BODY}>
            Weil Du mit Deinem jetzigen Denken und Fühlen immer wieder zu den gleichen Lösungen kommst, solange Du noch im alten Spielfeld unterwegs bist und den alten Spielregeln folgst.
          </p>
        </Reveal>
        <Reveal delay={0.12}>
          <p className={BODY}>Erst wenn Du Deine eigenen hinderlichen Programmierungen erkennst und veränderst, kannst Du Dich anders verhalten.</p>
        </Reveal>
        <Reveal delay={0.14}><p className={BODY}>Und dann passiert etwas fast Magisches:</p></Reveal>
        <Reveal delay={0.16}>
          <p className={`${BODY} font-600 text-espresso`} style={{ fontWeight: 600 }}>Du weißt plötzlich ganz genau, was Du wirklich, wirklich willst.</p>
        </Reveal>
        <Reveal delay={0.18}><p className={BODY}>Und gefühlt aus dem Nichts steht er vor Dir:</p></Reveal>
        <Reveal delay={0.2}>
          <p className="font-heading text-3xl font-700 uppercase tracking-tight text-cognac-2 md:text-5xl" style={{ fontWeight: 700 }}>Dein Traumjob.</p>
        </Reveal>
        <Reveal delay={0.22}>
          <p className={BODY}>
            Genau da setzt <strong style={{ fontWeight: 700 }}>Unverschämt Erfolgreich</strong> an: kein Schema F, das Dich in eine Schublade steckt, sondern ein Prozess, der Dir hilft, Dich selbst wirklich zu erkennen – und dann loszugehen.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <p className={BODY}>Von innen nach außen.</p>
        </Reveal>
        <Reveal delay={0.26}>
          <p className={BODY}>Und mit jemandem an Deiner Seite, der Dich wirklich sieht. Und Dir Deine blinden Flecken aufzeigt.</p>
        </Reveal>
        </div>
        <div className="md:col-span-5">
          <Reveal delay={0.15}>
            <div className="relative">
              <div className="absolute -inset-3 -z-10 bg-gold" />
              <img
                src={sonnenblumenImg}
                alt="Luisa Bergholz im Sonnenblumenfeld"
                width="1203"
                height="1757"
                className="w-full object-cover"
                loading="lazy"
              />
            </div>
          </Reveal>
        </div>
      </div>
    </Section>
  );
}
